import { bindActionCreators, } from 'redux';
import { connect, } from 'react-redux';
import * as SignupAction from '../actions/Signup';
import * as SigninAction from '../actions/Signin';
import SignUp from './SignUp';

function mapStateToProps(state){

  return{
    login: state.signin,
    register: state.signup,
    error: state.signup.error,
  }
}
function mapDispachToProps(dispatch){
  return bindActionCreators(Object.assign({},SigninAction, SignupAction), dispatch);
}
const SignUpContainer = connect(mapStateToProps, mapDispachToProps)(SignUp);
export default SignUpContainer;



/** WEBPACK FOOTER **
 ** ./src/components/SignUpContainer.js
 **/